import { Grid } from "../../primitives/grid";
import { Skeleton } from "../skeleton";

/**
 * A placeholder shaped like one `ContentTile`: a 16:9 thumbnail, then the title, meta line and
 * tag chips beneath it.
 *
 * `GridSkeleton` is the older bordered card with a footer row, which is a different component's
 * shape — using it under a `ContentTile` grid made the layout jump on load.
 */
export const ContentTileSkeleton = () => (
    <div className="mb-2 flex w-full flex-col">
        <Skeleton className="aspect-video w-full rounded-xl" />
        <div className="mt-3 flex flex-col gap-2">
            <Skeleton className="h-4 w-4/5" />
            <Skeleton className="h-3 w-2/5" />
            <div className="mt-0.5 flex gap-1">
                <Skeleton className="h-5 w-16 rounded-full" />
                <Skeleton className="h-5 w-20 rounded-full" />
            </div>
        </div>
    </div>
);

/**
 * A grid of them, matching the `Grid cols={3} gap="md"` the tile grids use. Just the grid — the
 * page keeps its own real header and filters while the tiles load.
 */
export const ContentGridSkeleton = ({ count = 6 }: { count?: number }) => (
    <Grid cols={3} gap="md" className="w-full items-stretch">
        {Array.from({ length: count }).map((_, i) => (
            <ContentTileSkeleton key={i} />
        ))}
    </Grid>
);
